import { render } from "./Billableitems.vue?vue&type=template&id=365b2516&scoped=true"
import script from "./Billableitems.vue?vue&type=script&lang=js"
export * from "./Billableitems.vue?vue&type=script&lang=js"

import "./Billableitems.vue?vue&type=style&index=0&id=365b2516&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365b2516"]])

export default __exports__